import React from "react";
import Loading from "./Components/Loading";
import { GTM, setGTM } from "./Helpers/tagManager";
import lazyView from "./Components/common/lazyView";
import ProductDetails from "./Components/common/ProductPageRoute";
import "./App.css";
import { isStorefrontBrowseEnabled } from "./Components/Storefront/featureFlags";
import "./Components/Storefront/StorefrontBrowse.css";

import * as Sentry from "@sentry/react";
import { buildFrontendErrorReport, reportFrontendError } from "./Helpers/frontendErrorReport";
import { connect } from "react-redux";
//Components
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import { Helmet } from "react-helmet";
import { Redirect, Route, withRouter } from "react-router-dom";
import Header from "./Components/Header";
import HomePage from "./Components/HomePage";
// import Loading from "./Components/Loading";

// import BranchDetail from "./Components/Branches/BranchDetail";

import instance from "../src/store/actions/instance";
import NoticeBanner from "./Components/Banner/Notice";
import PopupBanner from "./Components/Banner/Popup";
import {
  Apply_Promo,
  clearOrderPassData,
  refreshStorefrontOrderPassData,
  saveCustomerContact,
} from "./store/actions";
import { setBranchDeliveryCharge } from "./store/actions/branch";

//B2B

//Analytics
import googleTagManager from "@analytics/google-tag-manager";
import Analytics from "analytics";
import ReactGA from "react-ga4";
import SnapchatPixel from "react-snapchat-pixel";
import ReactAckoo from "./ackoo";
import PinterestPixel from "./PinterestPixel";
import TiktokPixel from "./tiktok-pixel";
import TwitterPixel from "./TwitterPixel";

//Ads
import GoogleAdsTracker from "./GoogleAdsTracker";
import Klaviyo from "./Klaviyo";

//Assets
import {
  createMuiTheme,
  ThemeProvider as MuiThemeProvider,
} from "@material-ui/core/styles";

//Actions
import SignUpModal from "./Components/common/SignUpModal";
import {
  fetchBranch,
  fetchStore,
  resetLocalStorage,
  setLanguage,
} from "./store/actions";
import {
  createCustomerWithAddressAndPhone,
  setUser,
} from "./store/actions/auth";
import { clearCart, loadCart } from "./store/actions/cart";

import WhatsAppWidget from "./Components/WhatsAppWidget";

import AreaSelect from "./Components/AreaSelect";

import Fab from "@material-ui/core/Fab";
import Snackbar from "@material-ui/core/Snackbar";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import MuiAlert from "@material-ui/lab/Alert";

import CallWaiterDiolog from "./Components/CallWaiterDialog";
import EbutlerWidget from "./Components/EbutlerWidget";
import InstagramWidget from "./Components/InstagramWidget";
import PromotionMessage from "./Components/Promotions/PromotionMessage";
import TikTokWidget from "./Components/TikTokWidget";

import CheckoutAuthOverlay from "./checkout-v2/components/CheckoutAuthOverlay";
import LegacyCheckoutRouteAdapter from "./checkout-v2/routes/LegacyCheckoutRouteAdapter";
import CartDrawerRoute from "./checkout-v2/routes/CartDrawerRoute";
import CartOverlaySwitch from "./checkout-v2/routes/CartOverlaySwitch";
import OrderContextRouteAdapter from "./checkout-v2/routes/OrderContextRouteAdapter";
import { isCheckoutV2Eligible, isCheckoutV2Enabled } from "./checkout-v2/domain/featureFlags";
import {
  canAddToCartBeforeBranchSelection,
  canUseSocialAuth,
} from "./Helpers/orderPass";

// Tabs
import Paper from "@material-ui/core/Paper";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { MenuBook, Person, Star } from "@material-ui/icons";
import { captureFacebookTestID, EnableFaceBook } from "./Helpers/analytics";

const Branches = lazyView(() => import("./Components/Branches"));
const Confirmation = lazyView(() => import("./Components/CheckoutProcess/Confirmation"));
const FirstStep = lazyView(() => import("./Components/CheckoutProcess/FirstStep"));
const SecondStep = lazyView(() => import("./Components/CheckoutProcess/SecondStep"));
const BranchDetail = lazyView(() => import("./Components/AreaSelect/BranchDetails"));
const Cart = lazyView(() => import("./Components/Cart"));
const CategoryDetailList = lazyView(() => import("./Components/GridView/CategoryDetailList"));
const Search = lazyView(() => import("./Components/Search"));
const PaymentFail = lazyView(() => import("./Components/CheckoutProcess/PaymentFail"));
const PaymentSuccess = lazyView(() => import("./Components/CheckoutProcess/PaymentSuccess"));
const MapPickerPage = lazyView(() => import("./Components/CheckoutProcess/SecondStep/MapPickerPage"));
const DigitalDownload = lazyView(() => import("./Components/DigitalDownload"));
const PastOrders = lazyView(() => import("./Components/PastOrders"));
const Profile = lazyView(() => import("./Components/Profile"));
const Points = lazyView(() => import("./Components/Profile/Points"));
const Wallet = lazyView(() => import("./Components/Profile/Wallet"));
const TrackingPage = lazyView(() => import("./Components/TrackingPage"));
const WaitList = lazyView(() => import("./Components/WaitList"));
const WaitListStatus = lazyView(() => import("./Components/WaitList/WaitList"));
const WaitListForm = lazyView(() => import("./Components/WaitList/WaitListForm"));
const B2B = lazyView(() => import("./Components/B2B"));
const DistributorFail = lazyView(() => import("./Components/B2B/Fail"));
const DistributorProductDetails = lazyView(() => import("./Components/B2B/ProductDetails"));
const DistributorSuccess = lazyView(() => import("./Components/B2B/Success"));
const DistributorOrderTracking = lazyView(() => import("./Components/B2B/Tracking"));
const WalletTopupProcess = lazyView(() => import("./Components/WalletTopupProcess"));
const EmailForgotPassword = lazyView(() => import("./Components/Profile/EmailForgotPassword"));
const ProfilePageV2 = lazyView(() => import("./Components/Profile/ProfilePageV2"));
const EmailSignin = lazyView(() => import("./Components/Profile/EmailSignin"));
const FavoriteProductPage = lazyView(() => import("./Components/ProductDetails/FavoriteProducts/FavoriteProductPage"));
const PhoneForgotPassword = lazyView(() => import("./Components/Profile/PhoneForgotPassword"));
const PhoneSignin = lazyView(() => import("./Components/Profile/PhoneSignin"));
const ProductFeedbackPage = lazyView(() => import("./Components/TrackingPage/ProductFeedback/ProductFeedbackPage"));
const CheckoutShell = lazyView(() => import("./checkout-v2/components/CheckoutShell"));
const OrderStatusV2 = lazyView(() => import("./checkout-v2/components/OrderStatusV2"));
const LoyaltyHomePage = lazyView(() => import("./Components/PromotionalStoreFront/LoyaltyHomePage"));
const Teasers = lazyView(() => import("./Components/Teasers"));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export { GTM } from "./Helpers/tagManager";

function EnableGoogle(ID) {
  ReactGA.initialize(ID);
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname + window.location.search,
  });
  ReactGA.event({
    category: "View Content",
    action: `View Content`,
    label: "View Content",
  });
}

function EnableGoogleTagManager(ID) {
  setGTM(Analytics({
    app: "app",
    plugins: [
      googleTagManager({
        containerId: ID,
      }),
    ],
  }));
  GTM.page();
  GTM.track("view_content");
}

function EnableAckoo(ID) {
  ReactAckoo.init(ID);
}
function EnableSnapChat(ID, Email) {
  const userIdentification = { user_email: Email }; // optional
  const options = {
    debug: false, // enable logs
  };
  SnapchatPixel.init(ID, userIdentification, options);

  SnapchatPixel.pageView(); // For tracking page view
  SnapchatPixel.track("VIEW_CONTENT", { integration: "ordable" });
}
export const shouldClearCartForMissingBranch = (settings = {}, branch = {}) =>
  !isCheckoutV2Enabled(settings) &&
  settings.is_branch_based_ordering &&
  !branch.branch &&
  settings.branch_count !== 1 &&
  !canAddToCartBeforeBranchSelection(settings);

export class App extends React.Component {
  constructor(props) {
    super(props);

    this.selector = React.createRef();
    this.lastOrderPassRefreshKey = null;
  }

  state = {
    signUpModalOpen: false,
    alertOpen: false,
    openWaiterDialog: false,

    currentTab: "homepage",
    lastHomePageLink: "/",
  };

  refreshOrderPassStorefrontData = async () => {
    const { settings, customer } = this.props;
    const verifiedPhone =
      customer?.orderPassVerifiedPhone || customer?.customerContact?.phone;
    const refreshKey = [
      this.props.store?.id || this.props.branch?.branch || "store",
      verifiedPhone || "",
    ].join(":");

    if (!this.props.store) {
      return;
    }

    if (!settings?.enable_orderpass) {
      if (
        customer?.orderPassPhone ||
        customer?.orderPassVerifiedPhone ||
        customer?.orderPassLinked ||
        customer?.orderPassStorefrontToken ||
        customer?.orderPassAddresses?.length ||
        customer?.orderPassGuestBypassPhone
      ) {
        this.props.clearOrderPassData();
      }
      this.lastOrderPassRefreshKey = null;
      return;
    }

    if (!verifiedPhone || this.lastOrderPassRefreshKey === refreshKey) {
      return;
    }

    this.lastOrderPassRefreshKey = refreshKey;
    await this.props.refreshStorefrontOrderPassData();
  };

  fullList = (side) => (
    <div>
      <List>
        <ListItem button>
          <ListItemIcon>
            <MailIcon />
          </ListItemIcon>
          <ListItemText primary={"WhatsApp"} />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem button>
          <ListItemIcon>
            {" "}
            <InboxIcon />{" "}
          </ListItemIcon>
          <ListItemText primary={"Store"} />
        </ListItem>
      </List>
    </div>
  );

  async componentDidCatch(error, info) {
    const isLocalhost = Boolean(
      window.location.hostname === "localhost" ||
      window.location.hostname == "192.168.43.120" ||
      window.location.hostname == "192.168.43.74" ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === "[::1]" ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
      ),
    );
    if (!isLocalhost) {
      if (this.reportingRenderError) return;
      this.reportingRenderError = true;
      let ErrorCount = null;
      try { ErrorCount = sessionStorage.getItem("ErrorCount"); } catch (_) {}
      const report = buildFrontendErrorReport(error, info, this.props, {
        attempt: (parseInt(ErrorCount, 10) || 0) + 1,
        action: "show_recovery_preserve_cart",
      });
      // Capture the original failure before reset erases context or reload
      // cancels its request. The reporter is bounded and cannot reject.
      await reportFrontendError(report, () => {
        const captured = new Error(report.error);
        captured.stack = JSON.parse(report.info).stack || captured.stack;
        Sentry.captureException(captured, scope => scope.setExtra("frontend_diagnostics", report.info));
      });

      // Neither humans nor renderers should be redirected/reloaded in a loop.
      // A missing asset or render failure is never proof of corrupt cart data.
      this.setState({ storefrontRecoveryError: true });
    }
  }
  TryApplyPromo = async (search) => {
    const params = new URLSearchParams(search);
    const promo_code =
      params.get("promotion") || this.props.applied_promo?.code;

    if (promo_code) {
      let promo = this.props?.store?.promos
        .concat(this.props.store.smart_promos)
        .find((promo) => promo.code === promo_code);
      if (promo) {
        if (promo?.id != this.props.applied_promo?.id) {
          this.props.Apply_Promo(promo);
        }
      } else {
        try {
          promo = await instance.post("coupon/", {
            code: promo_code,
            branch: this.props.branch?.branch,
            channel: this.props.channel,
          });

          this.props.Apply_Promo(promo.data);
        } catch (e) {
          this.props.Apply_Promo();
          sessionStorage.setItem("promo_code", search);
        }
      }
    }
  };

  captureSessionStart = () => {
    try {
      const thisSession = localStorage.getItem("sessionStart");
      if (thisSession) {
        const savedDate = new Date(thisSession);
        const now = new Date();
        const diffMs = now.getTime() - savedDate.getTime();
        const diffMinutes = diffMs / (1000 * 60);
        if (diffMinutes > 60) {
          localStorage.setItem("sessionStart", now.toISOString());
        }
      } else {
        localStorage.setItem("sessionStart", new Date().toISOString());
      }
    } catch (e) {}
  };
  componentDidMount = async () => {
    this.captureSessionStart();
    const paramsLang = new URLSearchParams(window.location.search);
    captureFacebookTestID(paramsLang);
    let language =
      paramsLang.get("lang") ||
      paramsLang.get("language") ||
      localStorage.getItem("language");
    let tn = null;
    if (language) {
      if (language === "en") language = "english";
      else if (language === "ar") language = "arabic";
      else if (!["english", "arabic"].includes(language)) language = "english";
      this.props.setLanguage(language);
    }
    if (!this.props.store) {
      // It goes here after authenticating with google for the first time
      // componentDidMount in /Profile/GoogleAuth.js handles the errors
      // and redirects back to /profile to remove the query params

      // const success = params.get("success");
      const token = paramsLang.get("auth_key");

      if (localStorage.getItem("stoken") && !token) {
        await this.props.setUser(
          localStorage.getItem("stoken"),
          this.props.history,
        );
      } else {
        if (token) {
          this.props.resetCustomersReducer();
          await this.props.setUser(token, this.props.history);
          this.props.history.replace(window.location.pathname, {
            prevPath: "profile",
          });
        }
      }

      const params = new URLSearchParams(window.location.search);
      if (params.get("src") === "haEubKB6T2") {
        this.props.setFromMobile();
      }

      if (params.get("src") === "Q7mZpL2xWa") {
        await this.props.resetLocalStorage();
        localStorage.clear();
        await this.props.resetCustomersReducer();
        await this.props.setUser();
        const userId = params.get("userId");
        localStorage.setItem("orderPlacedById", userId);
        const customerName = params.get("customerName");
        const customerPhone = params.get("customerPhone");
        const customerEmail = params.get("customerEmail");
        if (customerPhone) {
          await this.props.saveCustomerContact({
            name: customerName,
            phone: customerPhone,
            email: customerEmail,
          });
        }

        const block = params.get("block");
        const area_id = params.get("area_id");
        const country_id = params.get("country_id");
        const street = params.get("street");
        const building = params.get("building");
        const floor = params.get("floor");
        const apartment = params.get("apartment");
        const avenue = params.get("avenue");
        const additional = params.get("additional");
        const drawerBDC = params.get("branch_delivery_charge");
        const drawerBId = params.get("branch_id");
        if (drawerBDC) {
          await this.props.modifyAddress({
            block,
            street,
            building,
            floor,
            apartment,
            avenue,
            additional,
            selectedDeliveryType: 0,
            selectedAddressType: 0,
            area: parseInt(area_id),
            country: parseInt(country_id),
          });

          await this.props.setBranchDeliveryCharge({
            bdc: parseInt(drawerBDC),
            branch: parseInt(drawerBId),
            isPickup: false,
          });
        }
      } else {
        localStorage.removeItem("orderPlacedById");
      }

      tn = params.get("tn");
      const parkingNumber =
        params.get("pn") ||
        tn ||
        this.props.customer?.address?.token ||
        this.props.customer?.address?.parkingNumber;
      let branchID = params.get("b");
      if (branchID === "0") {
        this.props.resetLocalStorage();
        this.props.history.replace("/");
        window.location.reload(true);
        branchID = null;
      }
      let shouldFetchBranch = false;
      let qrCodeValid = false;
      let sessionID = null;
      if (parkingNumber) {
        if (!branchID)
          branchID = String(
            this.props.branch?.branch ||
              this.props.customer?.address?.pickupArea,
          );
        if (!branchID || branchID === "undefined" || branchID === "null") {
          try {
            const res = await instance.get("/should_fetch_branch/");
            shouldFetchBranch = res.data.fetchBranch;
            if (shouldFetchBranch) {
              branchID = res.data.branchID;
              await this.props.setBranchDeliveryCharge({
                isPickup: true,
                branch: parseInt(branchID),
              });
              this.props.preselectBranch(branchID);
            }
          } catch (e) {
            shouldFetchBranch = false;
          }
        }
        try {
          const res = await instance.post("/scan_qr/", {
            parkingNumber:
              parkingNumber ||
              this.props.customer?.address?.token ||
              this.props.customer?.address?.parkingNumber,
            branchID: branchID,
          });
          shouldFetchBranch = res.data.fetchBranch;
          qrCodeValid = res.data.valid;
          sessionID = res.data.session_id;

          if (shouldFetchBranch) {
            await this.props.setBranchDeliveryCharge({
              isPickup: true,
              branch: parseInt(branchID),
            });
          } else shouldFetchBranch = false;
        } catch (e) {
          console.error(e);
          shouldFetchBranch = false;
          qrCodeValid = false;
          sessionID = null;
        }
      } else {
        if (branchID) {
          try {
            const res = await instance.post("/scan_qr/", {
              branchID: branchID,
            });
            shouldFetchBranch = res.data.fetchBranch;
            if (shouldFetchBranch) {
              await this.props.setBranchDeliveryCharge({
                isPickup: true,
                branch: parseInt(branchID),
              });
              this.props.preselectBranch(branchID);
            }
          } catch (e) {
            shouldFetchBranch = false;
          }
        } else if (!this.props.branch.branch) {
          try {
            const res = await instance.get("/should_fetch_branch/");
            shouldFetchBranch = res.data.fetchBranch;
            if (shouldFetchBranch) {
              branchID = res.data.branchID;
              await this.props.setBranchDeliveryCharge({
                isPickup: true,
                branch: parseInt(branchID),
              });
              this.props.preselectBranch(branchID);
            }
          } catch (e) {
            shouldFetchBranch = false;
          }
        }
      }

      if (params.get("cart")) {
        await this.props.loadCart(
          params.get("cart"),
          this.props.history,
          params.get("new_address"),
        );
      }

      if (!this.props.branch.branch && !shouldFetchBranch) {
        await this.props.fetchStore(
          this.props.cart,
          this.props.applied_promo,
          this.props.history,
          null,
          qrCodeValid,
          parkingNumber,
          branchID,
        );
      } else if (this.props.branch.branch || shouldFetchBranch) {
        const selectedBranchID = shouldFetchBranch
          ? branchID || this.props.branch.branch
          : this.props.branch.branch || branchID;
        await this.props.fetchBranch(
          this.props.branch.isPickup == false && !shouldFetchBranch
            ? "delivery"
            : "pickup",
          this.props.branch.isPickup == false && !shouldFetchBranch
            ? this.props.branch.bdc
            : selectedBranchID,
          this.props.cart,
          this.props.applied_promo,
          this.props.history,
          null,
          qrCodeValid,
          selectedBranchID,
          parkingNumber,
        );
      }

      if (this.props.store) {
        await this.refreshOrderPassStorefrontData();
        if (this.shouldShowSignUpModal()) {
          this.setState({ signUpModalOpen: true });
        }
        if (
          !this.props.store.settings.is_branch_based_ordering &&
          this.props.branch.branch
        ) {
          this.props.clearBranch();
          this.props.clearStore();
          this.props.clearCart();
          window.location.reload();
          return;
        } else if (
          shouldClearCartForMissingBranch(this.props.store.settings, this.props.branch)
        ) {
          this.props.clearCart();
        }
        const settings = this.props.store.settings;

        if (settings.enable_table_qr && qrCodeValid && tn) {
          let dineInExpirationTime = new Date().getTime() + 60000 * 120;
          localStorage.setItem("dineInExpirationTime", dineInExpirationTime);
          localStorage.setItem("dineInSessionID", sessionID);
          const dineInExpirationTimeFromStorage = localStorage.getItem(
            "dineInExpirationTime",
          );
          this.props.modifyAddress({
            dineInExpirationTime: dineInExpirationTime,
            dineInSessionID: sessionID,
          });
          try {
            if (!dineInExpirationTimeFromStorage) {
              instance.post("log_error/", {
                title: "Dine in Fail Set Token",
                server_open_date: this.props.store.today_date,
                agent: navigator.userAgent,
                url: window.location.href,
                dineInExpirationTime: dineInExpirationTimeFromStorage,
              });
            }
          } catch (error) {}
        }

        if (settings.enable_fb_pixel && settings.fb_pixel) {
          EnableFaceBook(settings, this.props.customerContact);
        }
        const params = new URLSearchParams(document.location.search);
        const fbclid = params.get("fbclid"); //facebook id
        const ttclid = params.get("ttclid"); //tiktok id
        const sccid = params.get("ScCid"); // snpchat id
        const epik = params.get("epik"); // pinterest id

        if (fbclid) {
          const fbc = `fb.1.${Date.now()}.${fbclid}`;
          localStorage.setItem("fbc_2", fbc);
        }

        if (settings.enable_snap_pixel && settings.snap_pixel) {
          if (sccid) {
            localStorage.setItem("sccid", sccid);
          }
          EnableSnapChat(settings.snap_pixel, settings.snapchat_email || "");
        }

        if (settings.enable_pinterest && settings.pinterest_pixel) {
          if (epik) {
            localStorage.setItem("epik", epik);
          }
          PinterestPixel.init(settings.pinterest_pixel);
          PinterestPixel.track("pagevisit");
        }

        if (settings.enable_twitter_pixel && settings.twitter_pixel) {
          settings.twitter_events =
            JSON.parse(settings.twitter_events || "{}") || {};
          TwitterPixel.init(settings.twitter_pixel);

          if (settings.twitter_events["Page View"]) {
            TwitterPixel.track(settings.twitter_events["Page View"]);
          }
        }

        if (settings.enable_google_analytics && settings.google_analytics) {
          EnableGoogle(settings.google_analytics);
          this.props.history.listen((location, action) => {
            ReactGA.send({
              hitType: "pageview",
              page: window.location.pathname + window.location.search,
            });
          });
        }
        if (settings.enable_klaviyo && settings.klaviyo_company_id) {
          Klaviyo.init(settings.klaviyo_company_id);
        }

        if (settings.enable_google_manager && settings.google_manager_id) {
          EnableGoogleTagManager(settings.google_manager_id);
        }

        if (settings.enable_ackoo && settings.ackoo_api_key) {
          const params = new URLSearchParams(this.props.location.search);
          const token = params.get("session-token");
          if (token) {
            EnableAckoo(settings.ackoo_api_key);
          }
        }

        if (canUseSocialAuth(settings)) {
          this.props.createCustomerWithAddressAndPhone();
        }
        if (
          settings.enable_google_ads_tracker &&
          settings.google_ads_conversion_id &&
          settings.google_ads_conversion_label
        ) {
          GoogleAdsTracker.init("AW-" + settings.google_ads_conversion_id);
        }
        if (settings.enable_tiktok_pixel && settings.tiktok_pixel) {
          TiktokPixel.init(settings.tiktok_pixel);
          if (ttclid) {
            localStorage.setItem("ttclid", ttclid);
          }
        }
      }
    }

    const search = this.props.location.search;
    if (search || this.props.applied_promo) {
      this.TryApplyPromo(search, this.props.applied_promo);
    }
  };

  componentDidUpdate = (prevProps) => {
    const storeLoaded = this.props.store && !prevProps.store;
    const verifiedPhoneChanged =
      prevProps.customer?.orderPassVerifiedPhone !==
      this.props.customer?.orderPassVerifiedPhone;

    if (storeLoaded || verifiedPhoneChanged) {
      this.refreshOrderPassStorefrontData();
    }
    if (this.props.store != prevProps.store && prevProps.store != null) {
      this.props.setBranchLoadingFalse();
    }
    if (
      this.props.branch?.branch !== prevProps.branch?.branch &&
      sessionStorage.getItem("promo_code") &&
      !this.props.applied_promo
    ) {
      this.TryApplyPromo(sessionStorage.getItem("promo_code"));
    }
  };

  shouldShowSignUpModal = () => {
    const { settings, main_cart, store, auth } = this.props;
    if (!store || !settings) return false;
    if (
      settings.is_branch_based_ordering &&
      (this.props.history.location.pathname === "/select/branch" ||
        this.props.history.location.pathname === "/join")
    )
      return false;
    if (auth.user || !canUseSocialAuth(settings)) {
      localStorage.removeItem("signUpCount");
      return false;
    }

    if (settings.is_menu) return false;

    let num = parseInt(localStorage.getItem("signUpCount"));
    localStorage.setItem("signUpCount", parseInt(num || 1) + 1);
    if (!num && main_cart.cart.length) return true;
    if (!num) {
      return false;
    }
    num = parseInt(num);
    if (num == 2 || num % 10 == 0) return true;

    return false;
  };
  getMetaDescription = () => {
    const { store } = this.props;
    if (!store) return "";
    return (
      store.meta_description.substring(0, 160) ||
      store.slogan.substring(0, 160) ||
      `Order online directly from ${store.name}`
    );
  };
  getMetaTitle = () => {
    const { language, store } = this.props;
    if (!store) return "";
    if (language == "arabic") {
      return (
        store.meta_name.substring(0, 160) || store.ar_name.substring(0, 160)
      );
    }
    return store.meta_name.substring(0, 160) || store.name.substring(0, 160);
  };

  checkB2Broute = () => {
    const { pathname } = this.props.location;
    const { distributor_slug } = this.props.store.settings;

    if (distributor_slug && distributor_slug.length > 0) {
      const isB2B = [...distributor_slug, "distributor"].some((slug) =>
        pathname.includes(slug),
      );
      if (isB2B) {
        return true;
      }
    } else {
      return false;
    }
  };

  render() {
    if (this.state.storefrontRecoveryError) {
      const arabic = this.props.language === "arabic";
      return <main role="alert" dir={arabic ? "rtl" : "ltr"}
        style={{ padding: 24, textAlign: "center", fontFamily: "sans-serif" }}>
        <h1>{arabic ? "تعذر تحميل المتجر" : "We couldn’t load the store"}</h1>
        <p>{arabic ? "احتفظنا بسلتك. يرجى المحاولة مرة أخرى." : "Your cart has been kept. Please try again."}</p>
        <button type="button" onClick={() => window.location.reload()}
          style={{ minHeight: 44, padding: "10px 20px", borderRadius: 12, cursor: "pointer" }}>
          {arabic ? "إعادة المحاولة" : "Try again"}
        </button>
      </main>;
    }
    const {
      settings,
      isNotificationDismissed,
      address,
      language,
      cartSmartPromos,
    } = this.props;

    if (
      !this.props.store ||
      this.props.branch.loading ||
      (window.location.pathname.startsWith("/category") &&
        this.props.secondLoading)
    )
      return <Loading />;
    const showBanner =
      settings.enable_banner &&
      !this.props.isNotificationDismissed &&
      !this.props.isB2BNoticeBannerVisible;
    const checkoutV2Enabled = isCheckoutV2Eligible(settings, {
      address,
      cart: this.props.main_cart,
      isDistributorRoute: this.checkB2Broute(),
      pathname: this.props.location.pathname,
    });
    const checkoutV2Page = checkoutV2Enabled && this.props.location.pathname === "/checkout";
    const browseV2Page = (checkoutV2Enabled && this.props.location.pathname === "/cart") ||
      isStorefrontBrowseEnabled(settings, this.props.location.pathname, this.props.isB2B || this.checkB2Broute());
    const nativeCategoryScroll = browseV2Page && this.props.location.pathname === "/";

    const showBannerB2B =
      (this.props.distributorNoticeBannerOverride
        ? this.props.distributorNoticeBanner
        : this.props.settings.enable_banner_b2b) &&
      !this.props.isNotificationDismissedB2B;

    const showPopupBanner = settings.enable_popup_banner;
    const theme = createMuiTheme({
      palette: {
        primary: {
          main: this.props.store.settings.dark
            ? this.props.store.settings.dark
            : "#0099cc",
        },
      },
      typography: {
        fontFamily: ["Quicksand", "Cairo"].join(","),
      },
      overrides: {
        // Style sheet name ⚛️
        MuiDrawer: {
          // Name of the rule
          paperAnchorBottom: {
            // Some CSS
            left: this.props.language == "english" ? 0 : "auto !important",
          },
        },
      },
    });

    let ios =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    let insta = navigator.userAgent.match(/instagram/i);
    insta = false; //

    const { signUpModalOpen } = this.state;

    const callAWaiter = async () => {
      try {
        const res = await instance.post("/customer_at_location/", {
          table_number: address?.token,
        });
        this.setState({ alertOpen: true });
      } catch (e) {
        console.error(e);
      }
    };

    const enable_ebutler_widget =
      settings.enable_ebutler_widget_staff &&
      settings.enable_ebutler_widget &&
      settings.link_ebutler;

    return (
      <MuiThemeProvider theme={theme}>
        <Helmet>
          <title>{this.getMetaTitle()}</title>
          <meta name="description" content={this.getMetaDescription()} />
          <link rel="canonical" href={window.location.href} />
        </Helmet>

        {signUpModalOpen && !checkoutV2Enabled && (
          <SignUpModal
            open={true}
            onClose={() => this.setState({ signUpModalOpen: false })}
          />
        )}
        {checkoutV2Enabled && <CheckoutAuthOverlay />}

        {this.state.openWaiterDialog && (
          <CallWaiterDiolog
            onClose={() => this.setState({ openWaiterDialog: false })}
            onClick={() => {
              callAWaiter();
              this.setState({ openWaiterDialog: false });
            }}
            language={language}
          />
        )}
        {address?.token &&
          settings?.enable_table_qr &&
          settings.enable_pickup_arrival_requests &&
          this.props.history.location.pathname !== "/" && (
            <Fab
              size="small"
              color="primary"
              aria-label="call-waiter"
              onClick={() => this.setState({ openWaiterDialog: true })}
              style={{
                position: "fixed",
                top: 70,
                right: 10,
                zIndex: 999999,
              }}
            >
              <RoomServiceIcon />
            </Fab>
          )}

        <Snackbar
          open={this.state.alertOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ alertOpen: false })}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert
            onClose={() => this.setState({ alertOpen: false })}
            severity="success"
          >
            {language == "english"
              ? "A waiter has been notified!"
              : "تم ارسال اشعار لموظفي الخدمة"}
          </Alert>
        </Snackbar>

        <WhatsAppWidget />
        <InstagramWidget />
        <TikTokWidget />

        {enable_ebutler_widget && <EbutlerWidget />}

        {this.props.store.smart_promos.length > 0 &&
          !this.props.isB2B &&
          !this.checkB2Broute() &&
          (cartSmartPromos?.products?.length > 0 ||
            cartSmartPromos?.category_free?.length > 0) && <PromotionMessage />}

        <div
          className={"App container-fluid h-100 "
            .concat(
              this.props.language == "english" ? "english-font" : "arabic-font",
            )
            .concat(window.location.pathname == "/" ? " grayBackground" : "")
            .concat(checkoutV2Page ? " checkout-v2-page" : "")
            .concat(browseV2Page ? " sf-browse-page" : "")}
          id="main"
          ref={this.selector}
        >
          <div className="row" style={{ overflowY: nativeCategoryScroll ? "visible" : "scroll" }}>
            {!checkoutV2Page && this.props.language == "arabic" && (
              <div
                className="col-lg-7 col-md-7 h-100 d-md-none d-sm-none d-xs-none d-none d-lg-block d-md-block p-0 m-0"
                style={{
                  backgroundColor: "gray",
                  position: "fixed",
                  left: 0,
                  top: 0,

                  zIndex: 55,
                }}
              >
                <Header imageSize={"full"} style={{ overflowY: "hidden" }} />
              </div>
            )}

            <div
              className={(checkoutV2Page ? "checkout-v2-page__column col-12 p-0 w-100 " : "col-lg-5 col-md-5 col-12 p-0 w-100 ").concat(
                this.props.language == "arabic" ? "ml-auto" : "",
              )}
              style={{
                marginTop:
                  showBanner ||
                  (this.props.isB2BNoticeBannerVisible ? showBannerB2B : false)
                    ? "50px"
                    : "",
                // The v2 home rail sticks to the document. Overflow scroll/hidden
                // here creates a non-scrolling ancestor that traps native sticky.
                overflowY: nativeCategoryScroll ? "visible" : "scroll",
                overflowX: nativeCategoryScroll ? "clip" : "hidden",
                backgroundColor: "#f4f5f5",
                minHeight: "calc(100% - 60px )",
                height: "calc(100% - 60px)",
                // maxWidth: "42vw",
                // maxWidth: 400,
              }}
            >
              <NoticeBanner
                isB2B={this.props.isB2BNoticeBannerVisible}
                checkB2Broute={this.checkB2Broute()}
              />
              <div className="p-0 h-100">
                {!!this.props.settings &&
                  (!this.props.settings.is_menu ? (
                    <CartOverlaySwitch enabled={checkoutV2Enabled}>
                      <Route
                        exact
                        path="/checkout"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <CheckoutShell {...props} />
                          ) : (
                            <Redirect
                              to={{
                                pathname: "/checkout/details",
                                search: props.location.search,
                                hash: props.location.hash,
                                state: props.location.state,
                              }}
                            />
                          )
                        }
                      />
                      <Route
                        path="/select/branch"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <OrderContextRouteAdapter {...props} />
                          ) : (
                            <AreaSelect {...props} />
                          )
                        }
                      />
                      <Route path="/join" component={Teasers} />
                      <Route
                        path="/:slug/distributor/product/:CategorySlug/:ProductSlug"
                        component={DistributorProductDetails}
                      />
                      <Route
                        path="/product/:CategorySlug/:ParentProduct?/:ProductSlug"
                        component={ProductDetails}
                      />

                      <Route
                        path="/product/:ProductId"
                        component={ProductDetails}
                      />
                      <Route
                        path="/category/:categorySlug?"
                        component={CategoryDetailList}
                      />
                      <Route
                        path="/checkout/details"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <LegacyCheckoutRouteAdapter
                              {...props}
                              step="contact"
                            />
                          ) : (
                            <FirstStep {...props} />
                          )
                        }
                      />
                      <Route path="/Topup" component={WalletTopupProcess} />
                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist"
                          component={WaitListForm}
                        />
                      )}
                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist/track"
                          component={WaitList}
                        />
                      )}
                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist/status"
                          component={WaitListStatus}
                        />
                      )}
                      <Route
                        path="/checkout/address/map"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <LegacyCheckoutRouteAdapter {...props} step="map" />
                          ) : (
                            <MapPickerPage {...props} />
                          )
                        }
                      />
                      <Route
                        path="/checkout/address"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <LegacyCheckoutRouteAdapter
                              {...props}
                              step="address"
                            />
                          ) : (
                            <SecondStep {...props} />
                          )
                        }
                      />
                      <Route
                        path="/branch/:branchID"
                        component={BranchDetail}
                      />
                      <Route
                        path="/checkout/confirmation"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <LegacyCheckoutRouteAdapter
                              {...props}
                              step="review"
                            />
                          ) : (
                            <Confirmation {...props} />
                          )
                        }
                      />
                      <Route path="/contact" component={Branches} />
                      {this.props.store.settings.enable_tracking && (
                        <Route
                          path="/track/order/:tracking_id?/review"
                          component={ProductFeedbackPage}
                        />
                      )}

                      {this.props.store.settings.enable_tracking && (
                        <Route
                          path="/track/order/:tracking_id?"
                          component={TrackingPage}
                        />
                      )}
                      {this.props.store.settings.enable_tracking && (
                        <Route
                          path="/distributor/track/order/:tracking_id?"
                          component={DistributorOrderTracking}
                        />
                      )}
                      <Route
                        path="/success/:Tid?"
                        component={PaymentSuccess}
                      />

                      <Route
                        path="/fail/:Tid?/:pm?"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <OrderStatusV2 {...props} />
                          ) : (
                            <PaymentFail {...props} />
                          )
                        }
                      />
                      <Route
                        path="/distributor/success"
                        component={DistributorSuccess}
                      />
                      <Route
                        path="/distributor/fail"
                        component={DistributorFail}
                      />
                      <Route path="/track/previous" component={PastOrders} />
                      <Route
                        path="/download/:tracking_id?"
                        component={DigitalDownload}
                      />
                      {this.props.store.settings.enable_search && (
                        <Route path="/search" component={Search} />
                      )}
                      {checkoutV2Enabled && isStorefrontBrowseEnabled(settings, "/", this.props.isB2B || this.checkB2Broute()) && (
                        <Route path="/profile" component={ProfilePageV2} />
                      )}
                      {canUseSocialAuth(settings) && (
                        <Route
                          path="/profile/email-signin"
                          component={EmailSignin}
                        />
                      )}

                      {canUseSocialAuth(settings) &&
                        settings.enable_phone_login && (
                          <Route
                            path="/profile/phone-signin"
                            component={PhoneSignin}
                          />
                        )}

                      {canUseSocialAuth(settings) && (
                        <Route
                          path="/profile/forgot-password"
                          component={EmailForgotPassword}
                        />
                      )}

                      {canUseSocialAuth(settings) &&
                        settings.enable_phone_login && (
                          <Route
                            path="/profile/forgot-password-phone"
                            component={PhoneForgotPassword}
                          />
                        )}

                      <Route path="/profile" component={Profile} />
                      <Route path="/wallet" component={Wallet} />
                      {(settings.enable_aseer_time ||
                        settings.enable_loyalty_points_page) && (
                        <Route path="/rewards" component={LoyaltyHomePage} />
                      )}

                      <Route
                        path="/favorites"
                        component={FavoriteProductPage}
                      />
                      <Route path="/points" component={Points} />
                      <Route
                        path="/cart"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <CartDrawerRoute {...props} />
                          ) : (
                            <Cart {...props} />
                          )
                        }
                      />
                      {settings.enable_static_pages && (
                        <Route
                          path="/page/:slug"
                          render={(props) => (
                            <HomePage {...props} appRef={this.selector} />
                          )}
                        />
                      )}

                      <Route
                        path={`/:slug`}
                        exact
                        render={(props) => (
                          <B2B {...props} appRef={this.selector} />
                        )}
                      />
                      <Route
                        path="/"
                        render={(props) => (
                          <HomePage {...props} appRef={this.selector} />
                        )}
                      />
                    </CartOverlaySwitch>
                  ) : (
                    <CartOverlaySwitch enabled={checkoutV2Enabled}>
                      <Route
                        path="/cart"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <CartDrawerRoute {...props} />
                          ) : (
                            <Cart {...props} />
                          )
                        }
                      />
                      <Route
                        exact
                        path="/checkout"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <CheckoutShell {...props} />
                          ) : (
                            <Redirect
                              to={{
                                pathname: "/checkout/details",
                                search: props.location.search,
                                hash: props.location.hash,
                                state: props.location.state,
                              }}
                            />
                          )
                        }
                      />
                      <Route
                        path="/checkout/details"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <LegacyCheckoutRouteAdapter
                              {...props}
                              step="contact"
                            />
                          ) : (
                            <FirstStep {...props} />
                          )
                        }
                      />
                      <Route
                        path="/checkout/address/map"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <LegacyCheckoutRouteAdapter {...props} step="map" />
                          ) : (
                            <MapPickerPage {...props} />
                          )
                        }
                      />
                      <Route
                        path="/checkout/address"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <LegacyCheckoutRouteAdapter
                              {...props}
                              step="address"
                            />
                          ) : (
                            <SecondStep {...props} />
                          )
                        }
                      />
                      <Route
                        path="/checkout/confirmation"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <LegacyCheckoutRouteAdapter
                              {...props}
                              step="review"
                            />
                          ) : (
                            <Confirmation {...props} />
                          )
                        }
                      />
                      <Route
                        path="/product/:CategorySlug/:ParentProduct?/:ProductSlug"
                        component={ProductDetails}
                      />
                      <Route
                        path="/product/:ProductId"
                        component={ProductDetails}
                      />
                      <Route
                        path="/category/:categorySlug?"
                        component={CategoryDetailList}
                      />
                      <Route path="/contact" component={Branches} />
                      <Route
                        path="/select/branch"
                        render={(props) =>
                          checkoutV2Enabled ? (
                            <OrderContextRouteAdapter {...props} />
                          ) : (
                            <AreaSelect {...props} />
                          )
                        }
                      />
                      <Route
                        path="/branch/:branchID"
                        component={BranchDetail}
                      />
                      {this.props.store.settings.enable_tracking &&
                        (checkoutV2Enabled ||
                          this.props.settings.enable_car_qr ||
                          this.props.settings.enable_table_qr) && (
                          <Route
                            path="/track/order/:tracking_id?"
                            component={TrackingPage}
                          />
                        )}
                      {(checkoutV2Enabled ||
                        this.props.settings.enable_car_qr ||
                        this.props.settings.enable_table_qr) && (
                          <Route
                            path="/success/:Tid?"
                            component={PaymentSuccess}
                          />
                        )}
                      {(checkoutV2Enabled ||
                        this.props.settings.enable_car_qr ||
                        this.props.settings.enable_table_qr) && (
                          <Route
                            path="/fail/:Tid?/:pm?"
                            render={(props) =>
                              checkoutV2Enabled ? (
                                <OrderStatusV2 {...props} />
                              ) : (
                                <PaymentFail {...props} />
                              )
                            }
                          />
                      )}

                      {this.props.store.settings.enable_search && (
                        <Route path="/search" component={Search} />
                      )}

                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist"
                          component={WaitListForm}
                        />
                      )}
                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist/track"
                          component={WaitList}
                        />
                      )}
                      {this.props.store.settings.show_waiting_lists && (
                        <Route
                          exact
                          path="/waitlist/status"
                          component={WaitListStatus}
                        />
                      )}
                      {settings.enable_static_pages && (
                        <Route
                          path="/page/:slug"
                          render={(props) => (
                            <HomePage {...props} appRef={this.selector} />
                          )}
                        />
                      )}

                      <Route
                        path="/"
                        render={(props) => (
                          <HomePage {...props} appRef={this.selector} />
                        )}
                      />
                    </CartOverlaySwitch>
                  ))}
              </div>
              {(settings.enable_aseer_time ||
                settings.enable_loyalty_points_page) && (
                <Paper
                  className="d-lg-none d-xl-none d-md-none"
                  square
                  style={{
                    width: "100%",
                    position: "fixed",
                    bottom: -1,
                    zIndex: 100,
                  }}
                >
                  <Tabs
                    value={window.location.pathname}
                    onChange={(e, newValue) => {
                      // if (true || newValue !== this.state.currentTab) {
                      //   let newHomePageLink = this.state.lastHomePageLink;
                      //   if (this.state.currentTab == "homepage") {
                      //     newHomePageLink = window.location.pathname;
                      //   }
                      // this.setState({
                      //   currentTab: newValue,
                      //   lastHomePageLink: newHomePageLink,
                      // });

                      this.props.history.replace(newValue);
                      // this.props.history.replace(
                      //   (newValue === "homepage" && newHomePageLink) || newValue
                      // );
                      // }
                    }}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="icon tabs example"
                  >
                    <Tab icon={<MenuBook />} aria-label="menu" value={"/"} />

                    <Tab
                      icon={<Star />}
                      aria-label="rewards"
                      value={"/rewards"}
                    />

                    <Tab
                      icon={<Person />}
                      aria-label="profile"
                      value={"/profile"}
                    />
                  </Tabs>
                </Paper>
              )}
            </div>
            {showPopupBanner && !this.props.isB2B && !this.checkB2Broute() && (
              <PopupBanner isB2B={false} />
            )}
            {!checkoutV2Page && this.props.language == "english" && (
              <div
                className="col-lg-7 col-md-7 h-100 d-md-none d-sm-none d-xs-none d-none d-lg-block d-md-block p-0"
                style={{
                  backgroundColor: "gray",
                  overflowY: "hidden",
                  position: "fixed",
                  left: "41.64vw",
                  objectFit: "fill",
                }}
              >
                <Header imageSize={"full"} />
              </div>
            )}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    store: state.store.store,
    cart: state.cart.cart,
    main_cart: state.cart,
    price: state.cart.price,
    applied_promo: state.cart.promos,
    branch: state.branch,
    customer: state.customers,
    categories: state.store.store ? state.store.store.categories : [],
    current_product: state.store.current_product,
    secondLoading: state.store.secondLoading,
    settings: state.store.store ? state.store.store.settings : {},
    isNotificationDismissed: state.store.isNotificationDismissed,
    auth: state.auth,
    address: state.customers.address,
    isB2BNoticeBannerVisible: state.b2b.isB2BNoticeBannerVisible,
    isNotificationDismissedB2B: state.b2b.isNotificationDismissedB2B,
    distributorNoticeBanner: state.b2b.distributorNoticeBanner,
    distributorNoticeBannerOverride: state.b2b.distributorNoticeBannerOverride,
    isB2B: state.store.isB2B,
    cartSmartPromos: state.cart?.discounts,
    channel: state.promise.src,
    customerContact: state.customers?.customerContact,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchStore: (
      cart,
      promo,
      history,
      forceCurrency,
      qrCodeValid,
      qrToken,
      qrBranchID,
    ) =>
      dispatch(
        fetchStore(
          cart,
          promo,
          history,
          forceCurrency,
          qrCodeValid,
          qrToken,
          qrBranchID,
        ),
      ),
    setLanguage: (lan) => dispatch(setLanguage(lan)),
    fetchBranch: (
      type,
      bdc_id,
      cart,
      promo,
      history,
      forceCurrency,
      qrCodeValid,
      branchID,
      qrToken,
    ) =>
      dispatch(
        fetchBranch(
          type,
          bdc_id,
          cart,
          promo,
          history,
          forceCurrency,
          qrCodeValid,
          branchID,
          qrToken,
        ),
      ),
    setBranchLoadingFalse: () => dispatch({ type: "SET_BRANCH_LOADING_FALSE" }),
    clearStore: () => dispatch({ type: "CLEAR_STORE" }),
    clearBranch: () => dispatch({ type: "CLEAR_BRANCH" }),
    clearCart: () => dispatch(clearCart()),
    resetLocalStorage: () => dispatch(resetLocalStorage()),
    Apply_Promo: (promo) => dispatch(Apply_Promo(promo)),
    setUser: (key, history) => dispatch(setUser(key, history)),
    createCustomerWithAddressAndPhone: () =>
      dispatch(createCustomerWithAddressAndPhone()),
    setBranchDeliveryCharge: (data) => dispatch(setBranchDeliveryCharge(data)),
    preselectBranch: (branchID) =>
      dispatch({
        type: "MODIFY_ADDRESS",
        payload: {
          selectedDeliveryType: 1,
          pickupArea: parseInt(branchID),
          area: null,
          country: null,
          gpsConfirmed: false,
          lat: "",
          lng: "",
          block: "",
          street: "",
        },
      }),
    loadCart: (cart_uuid, history, new_address) =>
      dispatch(loadCart(cart_uuid, history, new_address)),
    setFromMobile: () => dispatch({ type: "SET_FROM_MOBILE" }),
    resetCustomersReducer: () => dispatch({ type: "RESET_CUSTOMERS_REDUCER" }),
    saveCustomerContact: (customer) => dispatch(saveCustomerContact(customer)),
    clearOrderPassData: () => dispatch(clearOrderPassData()),
    refreshStorefrontOrderPassData: () =>
      dispatch(refreshStorefrontOrderPassData()),

    modifyAddress: (address) =>
      dispatch({ type: "MODIFY_ADDRESS", payload: address }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
